import { CanvasTextAreaProps } from '../types/canvas-text-area.js';
import { calculateHexSizeBasedOnWidth } from './shapes/hexagon/calculate-hex-size-based-on-width.js';

export const getHexagonShapes = (x: number, y: number, width: number) => {
  const { hexSize, hexQuarterHeight, hexRadius } =
    calculateHexSizeBasedOnWidth(width);

  const topLeftVertex = { x: x - hexRadius, y: y - hexQuarterHeight };
  const topCenterVertex = { x, y: y - hexSize };
  const topRightVertex = { x: x + hexRadius, y: y - hexQuarterHeight };
  const bottomRightVertex = { x: x + hexRadius, y: y + hexQuarterHeight };
  const bottomCenterVertex = { x, y: y + hexSize };
  const bottomLeftVertex = { x: x - hexRadius, y: y + hexQuarterHeight };

  const halfWidth = width / 2;
  const leftBoundary = x - halfWidth;
  const rightBoundary = x + halfWidth;
  // Text area defined by the center of the square and filled with width and height
  const textArea: CanvasTextAreaProps = {
    x,
    y,
    width,
    height: hexSize,
    leftBoundary,
    rightBoundary,
  };

  const hexagonVertexes = [
    topLeftVertex,
    topCenterVertex,
    topRightVertex,
    bottomRightVertex,
    bottomCenterVertex,
    bottomLeftVertex,
  ];
  return { hexagonVertexes, textArea };
};
